import module from './headers.module'

export default module.name
